<th></th>
<th>
  <a (click)="sortBy('name')">
    <span>{{ "homepage.lists.column_structure" | translate }}</span>
    @if (sortValue === 'name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('updated_at')">
    <span>{{ "homepage.lists.column_updated_at" | translate }}</span>
    @if ( sortValue === 'updated_at' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'updated_at' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('sector_name')">
    <span>{{ "homepage.lists.column_sector_name" | translate }}</span>
    @if ( sortValue === 'sector_name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'sector_name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('created_at')">
    <span>{{ "homepage.lists.column_creation" | translate }}</span>
    @if ( sortValue === 'created_at' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'created_at' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
